<template>
  <div>
    <Top />
    <!-- 抬头 -->
    <div class="bg">
      <div class="home">
        <img src="@/assets/images/home_bg_title.png" alt />
      </div>
    </div>
    <!-- 公司新闻 -->
    <div class="news">
      <div class="home">
        <h1>公司新闻</h1>
        <h2>News information</h2>
        <div class="state clearfix">
          <el-carousel indicator-position="none" arrow="always" height="400px">
            <el-carousel-item v-for="item in dataList" :key="item.id">
              <div class="pictures">
                <router-link
                  :to="{ path: '/detail', query: { id: item.id } }"
                  target="_blank"
                >
                  <img
                    v-if="item.imgSrc"
                    :src="baseurl + '/ms/file/getimage/' + item.imgSrc[0]"
                    alt
                  />
                  <img v-else :src="require('@/assets/images/default_img.png')" alt="">
                  <div class="time">
                    <h3>{{ new Date(item.contentDatetime).getDate() }}</h3>
                    <span>{{
                      new Date(item.contentDatetime).getFullYear() +
                      "-" +
                      (new Date(item.contentDatetime).getMonth() + 1)
                    }}</span>
                  </div>
                  <div class="description">
                    <div class="ellipsis" :title="item.contentTitle">
                      {{ item.contentTitle }}
                    </div>
                  </div>
                </router-link>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="content">
            <div
              class="title ellipsis"
              :title="dataList[0].contentTitle"
              v-if="dataList[0]"
            >
              {{ dataList[0].contentTitle }}
            </div>
            <div class="detail" v-if="dataList[0]">
              {{ dataList[0].contentDetailsCN.slice(1, 80) }}...
              <router-link
                :to="{ path: '/detail', query: { id: dataList[0].id } }"
                target="_blank"
                >【详情】</router-link
              >
            </div>
            <ul class="newslist">
              <li
                class="ellipsis"
                v-for="ele in dataList.slice(1)"
                :key="ele.id"
              >
                <router-link
                  :to="{ path: '/detail', query: { id: ele.id } }"
                  target="_blank"
                  :title="ele.contentTitle"
                  >{{ ele.contentTitle }}</router-link
                >
              </li>
            </ul>
            <router-link :to="{ path: '/news' }" class="button fr"
              >更多 +</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 业务领域 -->
    <div class="business">
      <div class="home">
        <h1>业务领域</h1>
        <h2>Business area</h2>
        <ul class="tabs clearfix">
          <li>
            <img src="@/assets/images/business_3.png" alt />
            <p class="tab_p">经济社会大数据服务</p>
            <div class="tab_hover">
              <p class="tab_title">经济社会大数据服务</p>
              <span
                >全面系统整合经济社会发展重点、热点领域文献及数据，建设高质量的数据库，通过在线数据库、本地镜像、数据包等形式，向用户提供权威专业的经济社会大数据服务；基于国研网自身内容运营的信息资源和专业经验积累优势，面向党政机关、企事业单位提供自媒体内容代运营服务；从事特定领域信息、舆情的监测服务。</span
              >
              <router-link
                :to="{
                  path: '/product_service/data',
                  query: { param: '大数据产品', child: '文献库' },
                }"
                >查看详情</router-link
              >
            </div>
          </li>
          <li>
            <img src="@/assets/images/business_1.png" alt />
            <p class="tab_p">经济课题研究咨询</p>
            <div class="tab_hover">
              <p class="tab_title">经济课题研究咨询</p>
              <span
                >针对用户的个性化研究需求，依托权威专家资源和专业研究队伍，围绕宏观、区域、产业等领域，提供形势分析、政策研究、发展规划等方面的课题研究咨询服务。</span
              >
              <router-link
                :to="{
                  path: '/product_service/research',
                  query: { param: '政策规划咨询' },
                }"
                >查看详情</router-link
              >
            </div>
          </li>
          <li>
            <img src="@/assets/images/business_2.png" alt />
            <p class="tab_p">经济社会信息平台建设</p>
            <div class="tab_hover">
              <p class="tab_title">经济社会信息平台建设</p>
              <span
                >聚焦宏观、区域、产业经济领域，根据用户研究及决策需要，发挥国研网在信息内容、研究、技术上的综合优势，为各级政府、各类智库、企事业单位提供信息支撑平台建设以及运维服务。</span
              >
              <router-link
                :to="{
                  path: '/product_service/infor',
                  query: { param: '相关模型' },
                }"
                >查看详情</router-link
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 核心优势 -->
    <div class="solution">
      <div class="home">
        <h1>核心优势</h1>
        <h2>Core advantages</h2>
        <div class="content clearfix">
          <div class="fl left">
            <div class="piece">
              <strong>智库背景</strong>
              <p>
                国家级高端智库国务院发展研究中心下属单位，国研网为国务院发展研究中心窗口网站及其研究成果唯一授权网络发布渠道
              </p>
              <img src="@/assets/images/suit-tip.png" alt />
            </div>
            <div class="piece">
              <strong>专业团队</strong>
              <p>
                拥有包括国务院发展研究中心专家在内的强大专家顾问团队，并建立起了一支高效专业、素质过硬、经验丰富的研发团队
              </p>
              <img src="@/assets/images/suit-tip.png" alt />
            </div>
            <div class="piece">
              <strong>能力突出</strong>
              <p>
                在经济社会大数据服务、经济课题研究咨询、经济社会信息平台建设和国家高端智库建设服务等方面能力突出
              </p>
              <img src="@/assets/images/suit-tip.png" alt />
            </div>
          </div>
          <img class="fl center" src="@/assets/images/home_icon5.png" alt />
          <div class="fl right">
            <div class="piece">
              <strong>经验丰富</strong>
              <p>
                创建于1998年3月，拥有党政、教育、金融、企业机构用户800多家，连续多年成为全国两会指定服务机构，获得广大用户好评
              </p>
              <img src="@/assets/images/suit-tip.png" alt />
            </div>
            <div class="piece">
              <strong>实力雄厚</strong>
              <p>
                具有质量管理体系认证、双软认证等多种企业资质，获得系列计算机软件著作权登记证书、自主创新产品证书，是国家级高新技术企业
              </p>
              <img src="@/assets/images/suit-tip.png" alt />
            </div>
            <div class="piece">
              <strong>资源广泛</strong>
              <p>
                与国内外众多政府部门、知名智库、企事业单位、行业协会、财经媒体建立起了良好的合作伙伴关系，具有广泛的信息资源来源渠道
              </p>
              <img src="@/assets/images/suit-tip.png" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 典型客户 -->
    <div class="customer">
      <div class="home">
        <h1>典型客户</h1>
        <h2>Typical customer</h2>
        <ul class="tabs clearfix">
          <li>
            <router-link :to="{ path: '/customer/first' }">
              <img src="@/assets/images/customer_1.png" alt />
              <p class="tab_p">党政机关</p>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/customer/second' }">
              <img src="@/assets/images/customer_2.png" alt />
              <p class="tab_p">图情机构</p>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/customer/third' }">
              <img src="@/assets/images/customer_3.png" alt />
              <p class="tab_p">金融机构</p>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/customer/fourth' }">
              <img src="@/assets/images/customer_4.png" alt />
              <p class="tab_p">企事业单位</p>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="partner">
      <div class="home">
        <h1>合作伙伴</h1>
        <h2>Cooperative partner</h2>
        <div class="wk_scrollcontainer">
          <div class="wk_case_list">
            <a href="http://www.stats.gov.cn/" target="_blank">
              <div class="wk_case_img">
                <img src="@/assets/imgs/logo1.png" />
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>
          <div class="wk_case_list">
            <a href="http://www.customs.gov.cn/" target="_blank">
              <div class="wk_case_img">
                <img src="@/assets/imgs/logo22.png" />
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>
          <div class="wk_case_list">
            <a href="http://sg.km.gov.cn/" target="_blank">
              <div class="wk_case_img">
                <img src="@/assets/imgs/logo11.png" />
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>
          <div class="wk_case_list">
            <a href="https://www.chinaisa.org.cn">
              <div class="wk_case_img">
                <img src="@/assets/imgs/logo3.png" />
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>
          <div class="wk_case_list">
            <a href="http://www.caam.org.cn/" target="_blank">
              <div class="wk_case_img">
                <img src="@/assets/imgs/logo4.png" />
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>
          <div class="wk_case_list">
            <a href="http://www.cnlic.org.cn/" target="_blank">
              <div class="wk_case_img">
                <img src="@/assets/imgs/logo5.png" />
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>
          <div class="wk_case_list">
            <a href="http://www.cmisi.com.cn/" target="_blank">
              <div class="wk_case_img">
                <img src="@/assets/imgs/logo6.png" />
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>
          <div class="wk_case_list">
            <a href="http://cmif.mei.net.cn/" target="_blank">
              <div class="wk_case_img">
                <img src="@/assets/imgs/logo7.png" />
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>
          <div class="wk_case_list">
            <a href="http://www.cec.org.cn/" target="_blank">
              <div class="wk_case_img">
                <img src="@/assets/imgs/logo8.png" />
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>
          <div class="wk_case_list">
            <a href="http://www.cbmf.org/" target="_blank">
              <div class="wk_case_img">
                <img src="@/assets/imgs/logo9.png" />
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>
          <div class="wk_case_list">
            <a href="http://cpcia.org.cn" target="_blank">
              <div class="wk_case_img">
                <img src="@/assets/imgs/logo10.png" />
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>

          <div class="wk_case_list">
            <a href="http://jjxy.jlu.edu.cn/" target="_blank">
              <div class="wk_case_img">
                <img src="@/assets/imgs/logo12.png" />
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>

          <div class="wk_case_list">
            <a href="http://www.ccoic.cn" target="_blank">
              <div class="wk_case_img">
                <img src="@/assets/imgs/nlogo1.png" /> 
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>

          <div class="wk_case_list">
            <a href="http://obor.bisu.edu.cn" target="_blank">
              <div class="wk_case_img">
                <img src="@/assets/imgs/nlogo2.png" />
              </div>
              <div class="wk_case_ico"></div>
              <div class="wk_case_xian">
                <span class="wk_span_1"></span>
                <span class="wk_span_2"></span>
                <span class="wk_span_3"></span>
                <span class="wk_span_4"></span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- 友情链接 -->
    <div class="links">
      <div class="home">
        <h1>友情链接</h1>
        <h2>Links</h2>
        <div class="wk_service_main">
          <ul>
            <li>
              <a href="http://www.gov.cn/" target="_blank">
                <img src="@/assets/imgs/service_img21.png" />
                <div class="wk_case_ico2"></div>
                <div class="wk_case_xian2">
                  <span class="wk_span_1"></span>
                  <span class="wk_span_2"></span>
                  <span class="wk_span_3"></span>
                  <span class="wk_span_4"></span>
                </div>
              </a>
            </li>
            <li>
              <a href="http://www.drc.gov.cn/" target="_blank">
                <img src="@/assets/imgs/service_img1.png" />
                <div class="wk_case_ico2"></div>

                <div class="wk_case_xian2">
                  <span class="wk_span_1"></span>
                  <span class="wk_span_2"></span>
                  <span class="wk_span_3"></span>
                  <span class="wk_span_4"></span>
                </div>
              </a>
            </li>
            <li>
              <a href="http://www.cikd.org/" target="_blank">
                <img src="@/assets/imgs/service_img17.png" />
                <div class="wk_case_ico2"></div>
                <div class="wk_case_xian2">
                  <span class="wk_span_1"></span>
                  <span class="wk_span_2"></span>
                  <span class="wk_span_3"></span>
                  <span class="wk_span_4"></span>
                </div>
              </a>
            </li>
            <li>
              <a href="http://www.mwm.net.cn/" target="_blank">
                <img src="@/assets/imgs/service_img3.png" />
                <div class="wk_case_ico2"></div>
                <div class="wk_case_xian2">
                  <span class="wk_span_1"></span>
                  <span class="wk_span_2"></span>
                  <span class="wk_span_3"></span>
                  <span class="wk_span_4"></span>
                </div>
              </a>
            </li>
            <li>
              <a href="http://jjsb.cet.com.cn/" target="_blank">
                <img src="@/assets/imgs/service_img4.png" />
                <div class="wk_case_ico2"></div>
                <div class="wk_case_xian2">
                  <span class="wk_span_1"></span>
                  <span class="wk_span_2"></span>
                  <span class="wk_span_3"></span>
                  <span class="wk_span_4"></span>
                </div>
              </a>
            </li>
            <li>
              <a href="http://www.develpress.com.cn/" target="_blank">
                <img src="@/assets/imgs/service_img6.png" />
                <div class="wk_case_ico2"></div>
                <div class="wk_case_xian2">
                  <span class="wk_span_1"></span>
                  <span class="wk_span_2"></span>
                  <span class="wk_span_3"></span>
                  <span class="wk_span_4"></span>
                </div>
              </a>
            </li>

            <li>
              <a href="http://www.cdrf.org.cn/" target="_blank">
                <img src="@/assets/imgs/service_img7.png" />
                <div class="wk_case_ico2"></div>
                <div class="wk_case_xian2">
                  <span class="wk_span_1"></span>
                  <span class="wk_span_2"></span>
                  <span class="wk_span_3"></span>
                  <span class="wk_span_4"></span>
                </div>
              </a>
            </li>
            <li>
              <a href="http://www.srit.com.cn/" target="_blank">
                <img src="@/assets/imgs/service_img11.png" />
                <div class="wk_case_ico2"></div>
                <div class="wk_case_xian2">
                  <span class="wk_span_1"></span>
                  <span class="wk_span_2"></span>
                  <span class="wk_span_3"></span>
                  <span class="wk_span_4"></span>
                </div>
              </a>
            </li>
            <li>
              <a href="http://www.sritidc.com.cn/" target="_blank">
                <img src="@/assets/imgs/service_img12.png" />
                <div class="wk_case_ico2"></div>
                <div class="wk_case_xian2">
                  <span class="wk_span_1"></span>
                  <span class="wk_span_2"></span>
                  <span class="wk_span_3"></span>
                  <span class="wk_span_4"></span>
                </div>
              </a>
            </li>
            <li>
              <a href="http://www.sritnb.com.cn/" target="_blank">
                <img src="@/assets/imgs/service_img14.png" />
                <div class="wk_case_ico2"></div>
                <div class="wk_case_xian2">
                  <span class="wk_span_1"></span>
                  <span class="wk_span_2"></span>
                  <span class="wk_span_3"></span>
                  <span class="wk_span_4"></span>
                </div>
              </a>
            </li>
            <li>
              <a href="http://www.srcs.com.cn/" target="_blank">
                <img src="@/assets/imgs/service_img13.png" />
                <div class="wk_case_ico2"></div>
                <div class="wk_case_xian2">
                  <span class="wk_span_1"></span>
                  <span class="wk_span_2"></span>
                  <span class="wk_span_3"></span>
                  <span class="wk_span_4"></span>
                </div>
              </a>
            </li>

            <li>
              <a href="http://www.sritsoft.com/index.html" target="_blank">
                <img src="@/assets/imgs/service_img15.png" />
                <div class="wk_case_ico2"></div>
                <div class="wk_case_xian2">
                  <span class="wk_span_1"></span>
                  <span class="wk_span_2"></span>
                  <span class="wk_span_3"></span>
                  <span class="wk_span_4"></span>
                </div>
              </a>
            </li>
          </ul>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <!-- 飘窗 -->
    <!-- <div class="window" v-show="windowShow">
      <img src="@/assets/images/window.png" alt="" @click="window" />
      <div class="close" @click="windowShow = false">×</div>
    </div> -->
    <Footer />
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseurl: window.baseurl,
      dataList: [],
      // windowShow: true,
    };
  },
  created() {
    this.loadNews();
  },
  methods: {
    // 公司新闻
    async loadNews() {
      const { code, data } = await this.$api.get(
        "/cmsfront/IndexController/docListByMenuId",
        {
          menuId: "1498110650348503042",
          pageNum: 1,
          pageSize: 4,
        }
      );
      if (code === 0) {
        this.dataList = data.list;
      }
    },
    window() {
      let routeUrl = this.$router.resolve({ path: "/window" });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang='scss' scoped>
h1 {
  font-size: 36px;
  font-weight: 300;
  color: #333333;
  margin-top: 106px;
  text-align: center;
}
h2 {
  font-size: 22px;
  font-family: FZLanTingHei-L-GBK;
  font-weight: 400;
  color: #c4c4c4;
  text-align: center;
  margin-top: 15px;
}
.home {
  overflow: hidden;
}
// 飘窗
.window {
  // background: url(../assets/images/window.png) no-repeat;
  height: 300px;
  width: 150px;
  position: fixed;
  left: 50%;
  margin-left: -600px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 99;
  .close {
    position: absolute;
    content: "";
    display: block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(80, 80, 80, 0.8);
    right: 10px;
    top: 10px;
    color: #fff;
    text-align: center;
    font-size: 20px;
    line-height: 24px;
    cursor: pointer;
    z-index: 999;
  }
  a {
    display: block;
    height: 100%;
  }
}
// 抬头
.bg {
  background: url(../assets/images/home_bg.png) center;
  height: 465px;
  position: relative;
  img {
    margin-top: 149px;
    margin-left: 26px;
  }
  // ul {
  //   position: absolute;
  //   bottom: 0;
  //   transform: translateY(50%);
  //   li {
  //     width: 300px;
  //     height: 98px;
  //     float: left;
  //     font-size: 20px;
  //     font-family: FZLanTingHei-R-GBK;
  //     color: #fdfdfd;
  //     line-height: 98px;
  //     padding-left: 39px;
  //   }
  //   li:nth-child(1) {
  //     background: url(../assets/images/home_icon1.png) center;
  //   }
  //   li:nth-child(2) {
  //     background: url(../assets/images/home_icon2.png) center;
  //   }
  //   li:nth-child(3) {
  //     background: url(../assets/images/home_icon3.png) center;
  //   }
  //   li:nth-child(4) {
  //     background: url(../assets/images/home_icon4.png) center;
  //   }
  // }
}
// 公司新闻
.news {
  background: url(../assets/images/home-bg1.jpg) center no-repeat;
  overflow: hidden;
  .state {
    padding-top: 70px;
    padding-bottom: 112px;
    .el-carousel {
      float: left;
      width: 600px;
      height: 400px;
      .pictures {
        position: relative;
        img {
          width: 600px;
          height: 400px;
        }
        .time {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 96px;
          height: 73px;
          background: #e83636;
          text-align: center;
          h3 {
            font-size: 26px;
            font-weight: bold;
            color: #ffffff;
            line-height: 44px;
          }
          span {
            color: #ffffff;
          }
        }
        .description {
          position: absolute;
          background: linear-gradient(
            0deg,
            rgba(0, 0, 0, 1),
            rgba(0, 0, 0, 0.2)
          );
          width: 600px;
          line-height: 66px;
          bottom: 0px;
          color: #fff;
          font-size: 16px;
          padding: 0 20px;
          .ellipsis {
            line-height: 66px;
            width: 400px;
          }
        }
        a {
          display: block;
        }
      }
      /deep/.el-carousel__arrow {
        width: 22px;
        height: 22px;
        font-size: 24px;
        border-radius: 0;
        transform: translateY(740%);
      }
      /deep/.el-carousel__arrow--left {
        right: 120px;
        left: auto;
      }
      /deep/.el-carousel__arrow--right {
        right: 60px;
      }
    }
    .content {
      background: #fff;
      width: 600px;
      float: right;
      padding: 20px 58px;
      .title {
        font-size: 22px;
        font-weight: bold;
        color: #1a1a1a;
        line-height: 50px;
        margin-top: 10px;
      }
      .detail {
        width: 453px;
        color: #666666;
        line-height: 30px;
        padding-bottom: 10px;
        a {
          color: #368ad2;
        }
        a:hover {
          font-weight: 700;
        }
      }
      .newslist {
        border-top: 2px solid #ececec;
        padding: 10px 0px;
        li {
          a {
            color: #1a1a1a;
            line-height: 46px;
            font-size: 16px;
            &:hover {
              color: #368ad2;
              cursor: pointer;
            }
          }
        }
      }
      .button {
        display: block;
        width: 102px;
        height: 40px;
        background: #1072c6;
        border-radius: 1px;
        color: #fff;
        line-height: 40px;
        text-align: center;
      }
    }
  }
}
// 业务领域
.business {
  height: 692px;
  background: #f5f9fc;
  overflow: hidden;
  .tabs {
    margin-top: 46px;
    li {
      float: left;
      width: 377px;
      height: 386px;
      background: #ffffff;
      border-radius: 8px;
      position: relative;
      cursor: pointer;
      img {
        margin: 40px auto 20px;
        display: block;
      }
      .tab_p {
        font-size: 22px;
        color: #505050;
        line-height: 24px;
        text-align: center;
        &::after {
          content: "";
          display: block;
          width: 16px;
          height: 2px;
          background: #505050;
          margin: 20px auto;
        }
      }
      .tab_hover {
        position: absolute;
        background: url(../assets/images/bj1.png) no-repeat center;
        width: 377px;
        height: 386px;
        top: 0px;
        padding: 20px 40px;
        opacity: 0;
        transition: opacity 0.4s;
        .tab_title {
          font-size: 22px;
          color: #ffffff;
          line-height: 48px;
          text-align: center;
        }
        span {
          display: block;
          height: 210px;
          font-size: 15px;
          font-weight: 400;
          color: #fdfdfd;
          line-height: 27px;
        }
        a {
          display: block;
          margin: 20px auto 0;
          width: 114px;
          height: 30px;
          background: rgba(240, 240, 240, 0);
          border: 1px solid #ffffff;
          border-radius: 14px;
          font-size: 15px;
          color: #fdfdfd;
          line-height: 28px;
          text-align: center;
          &:hover {
            box-shadow: 0px 0px 5px #fff;
          }
        }
      }
      &:hover .tab_hover {
        opacity: 1;
        box-shadow: 0px 0px 40px #5fabecff;
      }
    }
    li:nth-child(2) {
      margin: 0 34px;
    }
  }
}
// 核心优势
.solution {
  h1 {
    margin-top: 86px;
  }
  .content {
    .left,
    .right {
      .piece {
        padding-left: 12px;
      }
    }
    .center {
      margin-left: 20px;
      margin-right: 20px;
      margin-top: 68px;
    }
    .piece {
      width: 100%;
      strong {
        font-size: 24px;
        color: #000000;
        line-height: 24px;
        font-weight: 400;
      }
      p {
        width: 280px;
        font-size: 14.4px;
        color: #515151;
        line-height: 24px;
        margin: 14px 0 6px 0;
      }
      &:nth-child(2) {
        margin: 60px 0;
      }
    }
  }
}
// 典型客户
.customer {
  background: url(../assets/images/customer_bg.jpg) bottom no-repeat;
  .tabs {
    margin: 60px 0;
    li {
      float: left;
      transition: all 0.4s;
      img {
        display: block;
      }
      a {
        display: block;
      }
      .tab_p {
        background: #fff;
        font-size: 22px;
        color: #010101;
        line-height: 70px;
        text-align: center;
        transition: all 0.4s;
      }
      &:hover {
        box-shadow: 0px 0px 30px #999;
        .tab_p {
          color: #1072c6;
        }
      }
    }
    li + li {
      margin-left: 39px;
    }
  }
}
/* 合作伙伴 */
.wk_scrollcontainer {
  position: relative;
  overflow: hidden;
  width: 1200px;
  padding-top: 40px;
  padding-bottom: 60px;
}
.wk_case_list {
  position: relative;
  border: 1px solid #ccc;
  float: left;
  overflow: hidden;
  margin: 0 20px 20px 0;
  width: 154px;
  height: 120px;
  background: #fff;
  .wk_case_img {
    position: relative;
    img {
      margin: 20px auto;
      width: 126px;
      display: block;
      height: 80px;
    }
  }
  .wk_case_ico {
    position: absolute;
    top: 0;
    left: 0;
    width: 152px;
    height: 120px;
    background: url(../assets/images/case_ico.png) no-repeat center;
    opacity: 0;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    -webkit-opacity: 0;
    -moz-opacity: 0;
  }
  .wk_case_xian {
    position: absolute;
    top: 16px;
    left: 16px;
    width: 120px;
    height: 85px;
  }
  span {
    position: absolute;
    background: #0ddfba;
    -webkit-transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    -moz-transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    -o-transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  .wk_span_1 {
    top: 0;
    left: 0;
    width: 0;
    height: 2px;
  }
  .wk_span_2 {
    top: 0;
    right: 0;
    width: 2px;
    height: 0;
  }
  .wk_span_3 {
    right: 0;
    bottom: 0;
    width: 0;
    height: 2px;
  }
  .wk_span_4 {
    bottom: 0;
    left: 0;
    width: 2px;
    height: 0;
  }
}
.wk_case_list:nth-child(7n) {
  margin-right: 0;
}
.wk_case_list:hover .wk_case_ico {
  opacity: 1;
  -webkit-opacity: 1;
  -moz-opacity: 1;
}

.wk_case_list:hover .wk_span_1,
.wk_case_list:hover .wk_span_3 {
  width: 100%;
}

.wk_case_list:hover .wk_span_2,
.wk_case_list:hover .wk_span_4 {
  height: 100%;
}
// 友情链接
.links {
  background: #f5f9fcff;
  .wk_service_main {
    position: relative;
    top: 40px;
    margin: 0 auto 120px;
    padding: 22px 0;
    width: 1200px;
    ul {
      overflow: hidden;
      li {
        border: 1px solid #e7eaedff;
        position: relative;
        float: left;
        overflow: hidden;
        margin: 0 10px 20px;
        width: 178px;
        height: 110px;
        background: rgba(255, 255, 255, 0.6);
        img {
          width: 100%;
        }
        span {
          position: absolute;
          background: #4cffff;
          -webkit-transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          -moz-transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          -o-transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        .wk_span_1 {
          top: 0;
          left: 0;
          width: 0;
          height: 2px;
        }
        .wk_span_2 {
          top: 0;
          right: 0;
          width: 2px;
          height: 0;
        }
        .wk_span_3 {
          right: 0;
          bottom: 0;
          width: 0;
          height: 2px;
        }
        .wk_span_4 {
          bottom: 0;
          left: 0;
          width: 2px;
          height: 0;
        }
      }
      li:hover .wk_span_1,
      li:hover .wk_span_3 {
        width: 100%;
      }
      li:hover .wk_span_2,
      li:hover .wk_span_4 {
        height: 100%;
      }
      li:hover .wk_case_ico2 {
        opacity: 1;
        -webkit-opacity: 1;
        -moz-opacity: 1;
      }
      li .wk_case_ico2 {
        position: absolute;
        top: 0;
        left: 0;
        width: 178px;
        height: 110px;
        background: url(../assets/imgs/case_ico.png) no-repeat center;
        opacity: 0;
        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
        -webkit-opacity: 0;
        -moz-opacity: 0;
      }
      .wk_case_xian2 {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 158px;
        height: 90px;
      }
    }
    .wk_case_list {
      position: relative;
      border: 1px solid #ccc;
      float: left;
      overflow: hidden;
      margin: 0 20px 20px 0;
      width: 220px;
      height: 120px;
      background: #fff;
    }
  }
}
</style>